/**
 * @param {number} num
 * @param {number} min
 * @param {number} max
 */
export function clamp(num, min, max) {
	return Math.min(Math.max(num, min), max);
}

/**
 * @param a {number}
 * @param b {number}
 */
export function nearlyEqual(a, b) {
	const epsilon = 0.5;
	return Math.abs(a - b) < epsilon;
}

/**
 * Determines if a number value is within a specified range.
 *
 * @param {number} value - the value to check
 * @param {number} min - the range start
 * @param {number} max - the range end
 * @returns {boolean}
 * @copyright - MIT License by https://github.com/microsoft/fast.
 */
export function inRange(value, min, max = 0) {
    [min, max] = [min, max].sort((a, b) => a - b);
    return min <= value && value < max;
}